var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-table", {
        ref: "table",
        attrs: {
          title: "LBL0001165",
          columns: _vm.grid.columns,
          gridHeight: _vm.grid.height,
          data: _vm.grid.data,
          merge: _vm.grid.merge,
          filtering: false,
          columnSetting: false,
          usePaging: false,
          editable: false,
        },
        scopedSlots: _vm._u([
          {
            key: "customArea",
            fn: function ({ props, col }) {
              return [
                col.name === "riskHazardPicture"
                  ? [
                      _c("q-btn", {
                        attrs: {
                          unelevated: "",
                          round: "",
                          dense: "",
                          size: "7px",
                          color: "primary",
                          icon: "wallpaper",
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.openHazardPicture(props)
                          },
                        },
                      }),
                    ]
                  : col.name === "picture"
                  ? [
                      _c("q-btn", {
                        attrs: {
                          unelevated: "",
                          round: "",
                          dense: "",
                          size: "7px",
                          color: "primary",
                          icon: "wallpaper",
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.openImprPicture(props)
                          },
                        },
                      }),
                    ]
                  : col.name === "ramRiskLevelName"
                  ? [
                      _c(
                        "q-chip",
                        {
                          style: `background-color:${props.row.riskColor};color:white;`,
                          attrs: { "text-color": "white" },
                        },
                        [_vm._v(" " + _vm._s(props.row[col.name]) + " ")]
                      ),
                    ]
                  : col.name === "customCol"
                  ? [
                      _c(_vm.imprComponent, {
                        tag: "component",
                        attrs: {
                          col: col,
                          props: props,
                          inputEditable: false,
                          requestContentsCols: _vm.requestContentsCols,
                          tableKey: "ramThirdAssessScenarioId",
                          ibmTaskTypeCd: "ITT0000013",
                          ibmTaskUnderTypeCd: "ITTU000015",
                        },
                        on: { imprChange: _vm.imprChange },
                      }),
                    ]
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }